import Utility from "../../../../utility/utility";
import EventManager from "../../../../manager/event_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CustomerItem extends cc.Component {
    
    
    

    @property(cc.RichText)
    myTalkLabel: cc.RichText = null;

    @property(cc.RichText)
    otherTalkLabel: cc.RichText = null;

    @property(cc.Sprite)
    myPlayerIcon: cc.Sprite = null;

    @property(cc.Sprite)
    otherPlayerIcon: cc.Sprite = null;

    @property(cc.Label)
    timeTxt: cc.Label = null;

    @property(cc.Node)
    myNode: cc.Node = null;

    @property(cc.Node)
    otherNode: cc.Node = null;

    @property(cc.Node)
    arrowNode: cc.Node = null;

    @property(cc.Label)
    seleTxt: cc.Label = null;

    @property(cc.Node)
    talkBg: cc.Node = null;

    @property(cc.Node)
    problemNode: cc.Node = null;

    // @property(cc.RichText)
    // anwerTxt: cc.RichText = null;

    // @property(cc.Node)
    // talkBg: cc.Node = null;

    itemId=0
    index=0;
    limitLen=16
    offset=80
    nodeHeight=0
    isProblemType:boolean=false
    isProblemList:boolean=false
    problemTypeArr:any[]  //咨询类型
    problemListArr:any[]  //常见问题
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }
    setData(i,data:any) {

      this.index=i
      
      
      this.timeTxt.string=data.time
      if(data.type==1)
      {
        this.myNode.active=true
        this.otherNode.active=false
        this.problemNode.active=false
        this.showMyNode(data)
      }
      else
      {
        this.myNode.active=false
        this.problemNode.active=false
        this.otherNode.active=true
      }
      this.showOtherNode(data)
      this.timeTxt.string=data.time   
    }
    getNodeHeight()
    {
        return this.nodeHeight
    }
    showMyNode(data:any)
    {
      let txt=this.checkTxt(data.content)
      //this.myTalkLabel.string=txt
      this.myTalkLabel.string=txt
      this.nodeHeight=this.myTalkLabel.node.getContentSize().height//Utility.getLabelSize(txt,this.myTalkLabel).height+this.offset
      
      //cc.log(this.myTalkLabel.node.height)
    }
    showOtherNode(data:any)
    {
      let txt
      if(data.problemContent)
      {
        txt=this.checkTxt(data.problemContent)
      }
      else
      {
        txt=this.checkTxt(data.content)
      }
      this.otherTalkLabel.string=txt
      // if(data.anwer)
      // {
      //   this.anwerTxt.node.active=true
      //   this.otherTalkLabel.node.active=false
      //   this.anwerTxt.string=txt
      //   this.nodeHeight=this.anwerTxt.node.height+this.offset
      // }
      // else
      // {
        //this.anwerTxt.node.active=false
        this.otherTalkLabel.node.active=true
        this.nodeHeight=this.otherTalkLabel.node.getContentSize().height//Utility.getLabelSize(txt,this.otherTalkLabel).height+this.offset
      // }
      
    }
    checkTxt(txt:string)
    {
      if(txt.length<=this.limitLen)
      {
        return txt
      }
      let num=Math.floor(txt.length/this.limitLen)+1
      let tempTxt:string=""
      let returnTxt:string=""
      for(let i=0;i<num;i++)
      {
        tempTxt=txt.substring(i*this.limitLen,(i*this.limitLen)+this.limitLen)
        if(i!=num-1)
        {
          tempTxt+="\n"
        }
        returnTxt+=tempTxt
      }
      
      return returnTxt
    }

  showProblemType(problemType: any[]) {

      this.timeTxt.string=problemType[0].createTime
      this.myNode.active=false
      this.otherNode.active=false
      this.problemTypeArr=problemType
      this.problemNode.active=true
      this.isProblemType=true;
      for(let i=0;i<problemType.length;i++)
      {
        let txtNode=this.instantiateObj(this.seleTxt.node,this.talkBg)
        txtNode.name="sele"+i
        txtNode.position.x=40
        let txt=txtNode.getComponent(cc.Label)
        //Utility.getLabelSize(problemType[i].problemTypeName,txt)
        this.nodeHeight+=txt.node.height
        txtNode.addComponent(cc.Button)
        txtNode.on('click', this.onClickProblemType, this)
      }
      this.nodeHeight+=this.offset
  }
  showProblemList(data: any[]) 
  {
    
    this.myNode.active=false
    this.otherNode.active=false
    this.problemNode.active=true
    this.problemListArr=data
    this.isProblemList=true;
    for(let i=0;i<data.length;i++)
    {
      let txtNode=this.instantiateObj(this.seleTxt.node,this.talkBg)
      txtNode.name="sele"+i
      txtNode.position.x=40
      let txt=txtNode.getComponent(cc.Label)
      //Utility.getLabelSize(data[i].problemContent,txt)
      this.nodeHeight+=txt.node.height
      txtNode.addComponent(cc.Button)
      txtNode.on('click', this.onClickProblem, this)
    }
    this.nodeHeight+=this.offset
  }
  protected onClickProblemType(event: cc.Button) 
  {
    let node: cc.Node = event.node
    for(let i=0;i<this.problemTypeArr.length;i++)
    {
      if(node.name=="sele"+i)
      {
        EventManager.instance.dispatch("send_problemId",this.problemTypeArr[i].problemTypeCode)
        break;
      }
    }
    
  }
  protected onClickProblem(event: cc.Button) 
  {
    let node: cc.Node = event.node
    for(let i=0;i<this.problemListArr.length;i++)
    {
      if(node.name=="sele"+i)
      {
        EventManager.instance.dispatch("showAnwer",this.problemListArr[i].answerContent)
        break;
      }
    }
    
  }

  instantiateObj(prefabNode: cc.Node, parent: cc.Node): cc.Node {
    var node = cc.instantiate(prefabNode)
    node.position = cc.v2(40, 0)
    node.scale = 1
    node.active=true
    node.parent = parent
    return node
  }
    // update (dt) {}
}
